import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("ec_admin_token");
export const setToken = (t) => {
  if (t) localStorage.setItem("ec_admin_token", t);
  else localStorage.removeItem("ec_admin_token");
};
export const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

axios.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && getToken() && !err.config?.url?.includes("/auth/login")) {
      setToken(null);
      window.location.reload();
    }
    return Promise.reject(err);
  }
);
